import AoneService from "../axiosbase";

//get pickup reasons
export const getPickupReasons = async (params) => {
  try {
    return await AoneService.get("ops/api/v1/reasons/pickup" + params);
  } catch (error) {
    return error;
  }
};

//post pickup reasons
export const postPickupReasons = async (data) => {
  try {
    return await AoneService.post("ops/api/v1/reasons/pickup", data);
  } catch (error) {
    return error;
  }
};

//edit pickup reasons
export const updatePickupReasonsById = async (params, data) => {
  try {
    return await AoneService.put("ops/api/v1/reasons/pickup/" + params, data);
  } catch (error) {
    return error;
  }
};

//delete pickup reasons
export const deletePickupReasonsById = async (params) => {
  try {
    return await AoneService.delete("ops/api/v1/reasons/pickup/" + params);
  } catch (error) {
    return error;
  }
};

//getbyId pickup reasons
export const getPickupReasonsById = async (params) => {
  try {
    return await AoneService.get("ops/api/v1/reasons/pickup/" + params);
  } catch (error) {
    return error;
  }
};

export const getPickupCategory = async () => {
  try {
    return await AoneService.get("ops/api/v1/reasons/pickup/event/category");
  } catch (error) {
    return error;
  }
};

//get pickup event category
export const getPickupEventCategory = async () => {
  try {
    return await AoneService.get("ops/api/v1/lookups/PickupEventCategory");
  } catch (error) {
    return error;
  }
};

export const getDeliveryEventCategory = async () => {
  try {
    return await AoneService.get("ops/api/v1/lookups/DeliveryEventCategory");
  } catch (error) {
    return error;
  }
};

//get pickup category
export const getOpsCategory = async () => {
  try {
    return await AoneService.get("ops/api/v1/lookups/Category");
  } catch (error) {
    return error;
  }
};

export const getOpsFailureType = async () => {
  try {
    return await AoneService.get("ops/api/v1/lookups/FailureResponsibility");
  } catch (error) {
    return error;
  }
};

//export pickup reasons
export const exportPickupReasons = async (params) => {
  try {
    return await AoneService.get("ops/api/v1/reasons/pickup/export" + params, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};

//get delivery reasons
export const getDeliveryReasons = async (params) => {
  try {
    return await AoneService.get("ops/api/v1/reasons/delivery" + params);
  } catch (error) {
    return error;
  }
};

//post delivery reasons
export const postDeliveryReasons = async (data) => {
  try {
    return await AoneService.post("ops/api/v1/reasons/delivery", data);
  } catch (error) {
    return error;
  }
};

//edit delivery reasons
export const updateDeliveryReasonsById = async (params, data) => {
  try {
    return await AoneService.put("ops/api/v1/reasons/delivery/" + params, data);
  } catch (error) {
    return error;
  }
};

//delete delivery reasons
export const deleteDeliveryReasonsById = async (params) => {
  try {
    return await AoneService.delete("ops/api/v1/reasons/delivery/" + params);
  } catch (error) {
    return error;
  }
};

//getbyId delivery reasons
export const getDeliveryReasonsById = async (params) => {
  try {
    return await AoneService.get("ops/api/v1/reasons/delivery/" + params);
  } catch (error) {
    return error;
  }
};

//export delivery reasons
export const exportDeliveryReasons = async (params) => {
  try {
    return await AoneService.get(
      "ops/api/v1/reasons/delivery/export" + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};

//get Hold reasons
export const getHoldReasons = async (params) => {
  try {
    return await AoneService.get("ops/api/v1/reasons/hold" + params);
  } catch (error) {
    return error;
  }
};

//post Hold reasons
export const postHoldReasons = async (data) => {
  try {
    return await AoneService.post("ops/api/v1/reasons/hold", data);
  } catch (error) {
    return error;
  }
};

//edit Hold reasons
export const updateHoldReasonsById = async (params, data) => {
  try {
    return await AoneService.put("ops/api/v1/reasons/hold/" + params, data);
  } catch (error) {
    return error;
  }
};

//delete Hold reasons
export const deleteHoldReasonsById = async (params) => {
  try {
    return await AoneService.delete("ops/api/v1/reasons/hold/" + params);
  } catch (error) {
    return error;
  }
};

//getbyId Hold reasons
export const getHoldReasonsById = async (params) => {
  try {
    return await AoneService.get("ops/api/v1/reasons/hold/" + params);
  } catch (error) {
    return error;
  }
};

//export Hold reasons
export const exportHoldReasons = async (params) => {
  try {
    return await AoneService.get(
      "ops/api/v1/reasons/hold/export" + params,
      {
        responseType: "blob",
      }
    );
  } catch (error) {
    return error;
  }
};
